module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.hasErrors) ? _c('div', {
    staticClass: "error-block"
  }, [_c('div', {
    staticClass: "error-icon"
  }, [_c('svg', {
    attrs: {
      "width": "50",
      "height": "50",
      "viewBox": "0 0 30 30",
      "fill": "none",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, [_c('path', {
    attrs: {
      "d": "M10.758 21.258C11.8832 20.1332 13.409 19.5013 15 19.5013C16.591 19.5013 18.1168 20.1332 19.242 21.258M10.5 12H10.515M19.5 12H19.515M28.5 15C28.5 16.7728 28.1508 18.5283 27.4724 20.1662C26.7939 21.8041 25.7995 23.2923 24.5459 24.5459C23.2923 25.7995 21.8041 26.7939 20.1662 27.4724C18.5283 28.1508 16.7728 28.5 15 28.5C13.2272 28.5 11.4717 28.1508 9.83377 27.4724C8.19588 26.7939 6.70765 25.7995 5.45406 24.5459C4.20047 23.2923 3.20606 21.8041 2.52763 20.1662C1.84919 18.5283 1.5 16.7728 1.5 15C1.5 11.4196 2.92232 7.9858 5.45406 5.45406C7.9858 2.92232 11.4196 1.5 15 1.5C18.5804 1.5 22.0142 2.92232 24.5459 5.45406C27.0777 7.9858 28.5 11.4196 28.5 15Z",
      "stroke": "#000",
      "stroke-width": "2",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  })]), _c('div', {
    staticClass: "error-label"
  }, [_vm._v("Ошибка")]), _vm._m(0)]), _c('div', {
    staticClass: "accordion"
  }, [_c('button', {
    staticClass: "accordion-button",
    on: {
      "click": _vm.toggleDetails
    }
  }, [_vm._v("\n      " + _vm._s(_vm.isOpen ? 'Скрыть детали ошибки' : 'Показать детали ошибки') + "\n    ")]), _c('transition', {
    on: {
      "enter": _vm.enter,
      "leave": _vm.leave
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isOpen),
      expression: "isOpen"
    }],
    ref: "accordion",
    staticClass: "accordion-content"
  }, [(_vm.errorMessage) ? _c('div', {
    staticClass: "error-main mt-4"
  }, [_vm._v("\n          " + _vm._s(_vm.errorMessage) + "\n        ")]) : _vm._e(), (_vm.errors.length) ? _c('ul', {
    staticClass: "error-list"
  }, _vm._l((_vm.errors), function(error, index) {
    return _c('li', {
      key: index,
      staticClass: "error-item"
    }, [_c('span', {
      staticClass: "error-msg"
    }, [_vm._v(_vm._s(error.msg))])])
  }), 0) : _vm._e()])])], 1)]) : _vm._e()
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "error-note"
  }, [_vm._v("\n      Нам очень жаль. Попробуйте обновить страницу или заглянуть к нам позже.\n      "), _c('br'), _vm._v("\n      Извините за технические проблемы.\n    ")])
}]}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-56a2bd8a","hasScoped":true,"preserveWhitespace":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/uikit/components/AppErrorsBlock/AppErrorsBlock.vue
// module id = 09f58a67a16b94125da3
// module chunks = 89